const {
  REACT_APP_BASE_URL_CAREPLIX,
  REACT_APP_BASE_URL,
  REACT_APP_API_KEY,
  REACT_APP_SECREATE_KEY,
  REACT_APP_PATIENTDIARY_BASE_URL,
  REACT_APP_PEAKFLOW_SMARTPAY_LINK,
  REACT_APP_ADDRESS_SHEET_LINK,
  REACT_APP_BOTPRESS_ID,
  REACT_APP_COMMON_URL,
  REACT_APP_CONTENT_URL
} = process.env;
// const { REACT_APP_BASE_URL } = process.env;
// const { REACT_APP_API_KEY } = process.env;
// const { REACT_APP_SECREATE_KEY } = process.env;
// const { REACT_APP_PATIENTDIARY_BASE_URL } = process.env;
// const { REACT_APP_PEAKFLOW_SMARTPAY_LINK, REACT_APP_ADDRESS_SHEET_LINK } = process.env;

export const BASE_URL_CAREPLIX = `${REACT_APP_BASE_URL_CAREPLIX}`;
export const BASE_URL = `${REACT_APP_BASE_URL}`;
export const ApiKey = `${REACT_APP_API_KEY}`;
export const SecreateKey = `${REACT_APP_SECREATE_KEY}`;
export const vitalspath = '/vital-scan';
export const vitalspathv2 = '/vital-scan/v2';

export const CONST_PATIENTDIARY_BASE_URL = `${REACT_APP_PATIENTDIARY_BASE_URL}`;
export const CONST_PEAKFLOW_SMARTPAY_LINK = `${REACT_APP_PEAKFLOW_SMARTPAY_LINK}`;
export const CONST_ADDRESS_SHEET_LINK = `${REACT_APP_ADDRESS_SHEET_LINK}`;
export const BOTPRESS_ID = `${REACT_APP_BOTPRESS_ID}`;
export const COMMON_URL = `${REACT_APP_COMMON_URL}`;
export const CONTENT_URL = `${REACT_APP_CONTENT_URL}`;